import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-classmaterial',
  templateUrl: './classmaterial.component.html',
  styleUrls: ['./classmaterial.component.css']
})
export class ClassmaterialComponent {
  @Input() file: any;
  @Input() adminuser:any;
  @Input() offlineUrl: string | null = null;
  @Output() deletefile: EventEmitter<any> = new EventEmitter();
  confirmDelete:boolean=false;

  deleteconfimed(fileid: number) {
    this.deletefile.emit(fileid);
  }

  popconfirmdelete(show: boolean)
  {
    this.confirmDelete = show;
  }
}
